export function mergeNullable<T>(
    a: T | undefined,
    b: T | undefined,
    mergeBoth: (a: T, b: T) => T,
    defaultVal: T,
): T;
export function mergeNullable<T>(
    a: T | undefined,
    b: T | undefined,
    mergeBoth: (a: T, b: T) => T,
    defaultVal?: T,
): T | undefined;
export function mergeNullable(
    a: unknown,
    b: unknown,
    mergeBoth: (a: unknown, b: unknown) => unknown,
    defaultVal?: unknown,
): unknown {
    if (a && b) return mergeBoth(a, b);
    if (a === undefined && b === undefined) return defaultVal;

    return a || b;
}

export const concat = <T>(...args: Array<T | Array<T>>): T[] => ([] as T[]).concat(...args);

export function concatUniqByProp<K extends string>(
    prop: K,
): <T extends Record<K, unknown>>(as: T[], bs: T[]) => T[] {
    return (as, bs) => [...as, ...bs.filter(b => !as.find(a => a[prop] === b[prop]))];
}
